import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Icon from "./Icon";
import { useI18n } from "../i18n";
import { C } from "../theme";

const TABS = [
  { path: "/dashboard", labelKey: "nav.dashboard", icon: "grid" },
  { path: "/attractions", labelKey: "nav.attractions", icon: "cube" },
  { path: "/ledger", labelKey: "nav.auditLog", icon: "document-text" },
  { path: "/settings", labelKey: "nav.settings", icon: "settings" },
];

export default function BottomTabs() {
  const nav = useNavigate();
  const loc = useLocation();
  const { t: tr } = useI18n();
  return (
    <div
      style={{
        position: "sticky", bottom: 0, left: 0, right: 0, display: "flex",
        background: C.card, borderTop: `1px solid ${C.border}`, height: 76,
        paddingTop: 8, paddingBottom: "env(safe-area-inset-bottom)", zIndex: 20,
      }}
    >
      {TABS.map((t) => {
        const active = loc.pathname === t.path;
        return (
          <button
            key={t.path}
            data-testid={`tab-${t.path.slice(1)}`}
            className="pressable"
            onClick={() => nav(t.path)}
            style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3, color: active ? C.amber : C.muted }}
          >
            <Icon name={t.icon} size={24} color={active ? C.amber : C.muted} />
            <span style={{ fontSize: 12, fontWeight: 700 }}>{tr(t.labelKey)}</span>
          </button>
        );
      })}
    </div>
  );
}
